import type { FC, ReactNode } from 'react';

import type { IconName } from '@similarweb/icons';
import { SWReactIcons } from '@similarweb/icons';

import type { ContactVariant, PrivateDataType } from '../../../../../domain/contact';

import { StyledPrivateDataItem, StyledPrivateDataContent, StyledPrivateDataWrapper } from './styles';

type Props = {
  content: ReactNode;
  type: PrivateDataType;
  isUnavailable?: boolean;
  withBluredContent?: boolean;
  tooltip?: ReactNode;
  animatedMount?: boolean;
  variant?: ContactVariant;
  info?: ReactNode;
};

const typeToIconMap: Record<PrivateDataType, IconName> = {
  email: 'email',
  'direct-phone': 'phone',
  'mobile-phone': 'mobile-ios',
};

export const PrivateDataBaseItemView: FC<Props> = ({
  content,
  type,
  isUnavailable = false,
  withBluredContent = false,
  tooltip,
  animatedMount = false,
  variant = 'listItem',
  info,
}) => {
  return (
    <StyledPrivateDataItem data-automation="ContactData" isUnavailable={isUnavailable}>
      <SWReactIcons iconName={typeToIconMap[type]} size="xs" className={type} />
      <StyledPrivateDataWrapper>
        <StyledPrivateDataContent
          increasedFontSize={variant === 'singular'}
          isUnavailable={isUnavailable}
          withBlur={withBluredContent}
          animatedMount={animatedMount}
        >
          {content}
        </StyledPrivateDataContent>
        {info}
      </StyledPrivateDataWrapper>
      {tooltip}
    </StyledPrivateDataItem>
  );
};
